import {
  OrderProductOption,
  orderProductOptionFromResponse,
} from './OrderProductOption';
import { OrderTotal, orderTotalFromResponse } from './OrderTotal';
import {
  ProductMedia,
  productMediaFromResponse,
} from '../Product/ProductMedia';

export interface OrderProduct {
  id: number;
  name: string;
  options: OrderProductOption[];
  companyPrice: OrderTotal;
  qty: number;
  lineTotal: OrderTotal;
  discount: OrderTotal;
  productID: number;
  barcode?: string;
  sku?: string;
  media?: ProductMedia;
  discountedAtCheckout: boolean;
}

export const orderProductFromResponse = (responseData: any): OrderProduct => ({
  id: responseData.id,
  name: responseData.product.name,
  options: (responseData.options ?? []).map(orderProductOptionFromResponse),
  companyPrice: orderTotalFromResponse(responseData.company_price),
  qty: responseData.qty,
  lineTotal: orderTotalFromResponse(responseData.line_total),
  discount: orderTotalFromResponse(responseData.discount),
  productID: responseData.product_id,
  barcode: responseData.barcode,
  sku: responseData.sku,
  media: responseData.media
    ? productMediaFromResponse(responseData.media)
    : undefined,
  discountedAtCheckout: responseData.discounted_at_checkout,
});
